import { useEffect } from 'react';
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TabPanelProps } from "../../screens/Tabs.MUI/Tabs.interface";
import View from "../../assets/view.svg";
import DeleteIcon from "../../assets/Delete.svg";
import { StartButton, TabButton } from "./Profile.styled";
import Info from "./Info";

import User, { ProfileUpdateData } from "../../stores/UserStore";
import BankDetails from "./BankDetails";
import { observer } from "mobx-react";
import MyDocuments from "./MyDocuments";
import { ToastContainer } from "react-toastify";
import General from '../../stores/GeneralStore'

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, padding: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default observer(function ProfileTabs() {
  const [value, setValue] = React.useState(0);
  const [userProfile, setUserProfile] = React.useState<any>({})
  const [updateLoader, setUpdateLoader] = React.useState(false);
  const [bankLoader, setBankLoader] = React.useState(false);

  const getSelectedBankName = () => {
    const value = JSON.parse(localStorage.getItem("selectedBankName") ?? JSON.stringify({ bankName: '', id: "" })) || { bankName: '', id: "" };
    return value;
  }

  const getUser = async () => {
    const res: any = await User.getProfile(User.info.personId as string);
    if (res) {
      setUserProfile(res?.result);
    }

  }
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleProfileUpdate = async (data: ProfileUpdateData) => {
    //TODO:favouriteServiceDeliveryChannel, gender ... should be objects
    setUpdateLoader(true);
    const res = await User.updateProfile({ errorId: "updateBankDetailsError", data });
    if (res) {
      setUpdateLoader(false)
      getUser();
    }
    setUpdateLoader(false)
  };

  const ViewComponent = () => {
    return <img src={View} alt="" />;
  };

  const TabButtons = (props: any) => {
    return <TabButton>{props.text}</TabButton>;
  };

  const loadBankDetails = async () => {
    await User.getBankData({
      errorId: "getBankDataError",
      data: User.info.personId,
    });
  };

  const handleSaveDetails = async (data: any) => {
    setBankLoader(true);
    await User.updateBankDetails({ errorId: 'updateBankDetailsError', data })
    setBankLoader(false);
    loadBankDetails()
  };

  const handleDelete = async (data: any) => {
    const res = await User.updateBankDetails({
      errorId: "updateBankDetailsError",
      data,
    });

    if (res?.result?.cmRefundBankAccountService?.input?.action == "DELETE") {
      loadBankDetails()
    }
  };

  const handleSaveAndUpdate = async (files: any) => {
    await User.updateDocuments(files);
  };
  const [isUpdate, setUpdate] = React.useState(false)
  useEffect(() => {

  }, [isUpdate])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div style={{ backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : "" }}>
      {/* <ToastContainer /> */}
      <Box sx={{ width: "100%", paddingBottom: "10vh" }}>
        <Box sx={{
          alignSelf: General?.isLargeScreen ? "" : 'center', 
          background: contrast?.contrastBackground ? contrast?.contrastBackground : "#E7E9F8", 
          paddingLeft: General?.isLargeScreen ? General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode != "ARA" ? "80px" : '' : "",
          paddingRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "80px" : '',
        }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{ width: "100%", }}
            variant="scrollable"
            allowScrollButtonsMobile
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            <Tab
              label={
                <span

                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: value === 0 ? contrast?.contrastColor ? contrast?.contrastColor : ColorAss : contrast?.contrastBackground ? contrast?.contrastBackground : "white",
                    background: value === 0 ? contrast?.contrastBackground ? contrast?.contrastBackground : '#fff' : contrast?.contrastColor ? contrast?.contrastColor : ColorAss

                  }}>
                  {General?.codeLabels["cm_personaldetails"]?.label !== undefined ? General?.codeLabels["cm_personaldetails"]?.label : "PERSONAL DETAILS"}

                </span>}
              {...a11yProps(0)}
              className={`${value === 0 ? contrast?.contrastBackground ? contrast?.contrastBackground : "innerTab" : "notselected"}`}
              sx={{
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", 
                background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                height: General?.isLargeScreen ? "3.75rem" : "2rem",
                width: General?.isLargeScreen ? "16.75rem" : "12rem",
                fontSize: "1.125rem",
                fontWeight: "bold",
                marginRight: "0.2rem", zIndex: '0'
              }}
            />

            <Tab
              label={
                <span
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: value === 1 ? contrast?.contrastColor ? contrast?.contrastColor : ColorAss : contrast?.contrastBackground ? contrast?.contrastBackground : "white",
                    background: value === 1 ? contrast?.contrastBackground ? contrast?.contrastBackground : '#fff' : contrast?.contrastColor ? contrast?.contrastColor : ColorAss
                  }}>
                  {General?.codeLabels["cm_bankdetails"]?.label !== undefined ? General?.codeLabels["cm_bankdetails"]?.label : "BANK DETAILS"}

                </span>}
              {...a11yProps(1)}
              className={` ${value === 1 ? contrast?.contrastBackground ? contrast?.contrastBackground : "innerTab" : "notselected"}`}
              sx={{
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", 
                background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
                height: General?.isLargeScreen ? "3.75rem" : "2rem",
                width: General?.isLargeScreen ? "16.75rem" : "12rem",
                fontSize: "1.125rem",
                fontWeight: "bold", zIndex: '0'
              }}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Info userProfile={userProfile} Submit={handleProfileUpdate} setUpdate={setValue} updateLoader={updateLoader} />
          {/*updateContactDetails={handleUpdateContactDetails}*/}
        </TabPanel>

        {/* <TabPanel value={value} index={1}>
        <MyDocuments saveAndUpdate={handleSaveAndUpdate}/>
      </TabPanel> */}

        <TabPanel value={value} index={1}>
          <BankDetails
            bankData={{...User.bankData}}
            loadBankDetails={loadBankDetails}
            saveDetails={handleSaveDetails}
            bankLoader={bankLoader}
            deleteDetails={handleDelete}
            // bankDetails={{...getSelectedBankName(),otherBankName: localStorage.getItem("otherBankName") ?? ""}}
          />
        </TabPanel>
      </Box>
    </div>
  );
});
